import { ActionTree } from "vuex";

import { RootState } from "@/store";

import { SET_DASHBOARD_LIST } from "./mutations";
import { DashboardState } from "./state";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchDashboardListCommand } from "@/model/communication/dashboard/dashboard/FetchDashboardListCommand";
import { Dashboard } from "@/model/data/dashboard/Dashboard";

export const FETCH_DASHBOARD_LIST = "FETCH_DASHBOARD_LIST";

export default {
    async [FETCH_DASHBOARD_LIST]({ rootState, commit }) {
        var res = await new FetchDashboardListCommand().execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            var unorderedDashboardList = res.dashboards;

            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                var orderedDashboardList: Dashboard[] = [];

                rootState.authMod.currentUser.userConfig.dashboardList.forEach((dashboardId) => {
                    var dashboard = unorderedDashboardList.find((c) => c.id == dashboardId);
                    if (dashboard) {
                        orderedDashboardList.push(dashboard);
                    }
                });

                // aggiungo in coda quelle non prensenti nell'userConfig
                unorderedDashboardList.forEach((dashboard) => {
                    if (!orderedDashboardList.map((d) => d.id).includes(dashboard.id)) {
                        orderedDashboardList.push(dashboard);
                    }
                });

                commit(SET_DASHBOARD_LIST, orderedDashboardList);
            } else {
                // le salvo comunque non ordinate
                commit(SET_DASHBOARD_LIST, res.dashboards);
            }
        }
    },
} as ActionTree<DashboardState, RootState>;
